"use client";

import { getCookie as nextGetCookie } from "cookies-next";
import { useEffect } from "react";


type KeyValue = Record<'key' | 'value', string | undefined>;

export const updateParams = (glLinker: any) => {
  
  let opt = '';
  
  const OptanonConsent: KeyValue = {
    key: 'OptanonConsent',
    value: nextGetCookie("OptanonConsent") as string | undefined,
  };
  const OptanonAlertBoxClosed: KeyValue = {
    key: 'OptanonAlertBoxClosed',
    value: nextGetCookie('OptanonAlertBoxClosed') as string | undefined,
  };

  if (OptanonConsent.key && OptanonConsent.value) {
    opt += `&OptanonConsent=${btoa(OptanonConsent.value)}`;
  }

  if (OptanonAlertBoxClosed.key && OptanonAlertBoxClosed.value) {
    opt += `&OptanonAlertBoxClosed=${btoa(OptanonAlertBoxClosed.value)}`;
  }
  return glLinker+opt;
}; 

export const CheckOneTrustGroup = () => {

  useEffect(() => {

    const cookieValue = nextGetCookie('OptanonConsent') as string | undefined;
  
  if (cookieValue) {
    const groupsParam = cookieValue.split('&').find(param => param.startsWith('groups='));
    
    if (groupsParam) {
      const groupsValue = groupsParam.split('=')[1];
      const groupPairs = groupsValue.split(',');
      const c0002Group = groupPairs.find(pair => pair.startsWith('C0002:'));

      if (c0002Group) {
        const c0002Value = c0002Group.split(':')[1];
        if (c0002Value === '1') {
          (window as any).SalesforceInteractions?.init({
            consents: [{
                provider: 'OneTrust',
                purpose: 'Tracking',
                status: (window as any).SalesforceInteractions?.ConsentStatus.OptIn
            }]
        });
        } else if (c0002Value === '0') {
          (window as any).SalesforceInteractions?.init({
            consents: [{
                provider: 'OneTrust',
                purpose: 'Tracking',
                status: (window as any).SalesforceInteractions?.ConsentStatus.OptOut
            }]
        });
        }
      }
    }
  }
  }, []);
  return null;
  
};





